import { createGlobalStyle } from "styled-components";
import InterRegularWoff2 from "./inter/Inter-Regular.woff2";
import InterItalicWoff2 from "./inter/Inter-Italic.woff2";
import InterBoldWoff2 from "./inter/Inter-Bold.woff2";
import InterBoldItalicWoff2 from "./inter/Inter-BoldItalic.woff2";
import InterDisplayRegularWoff2 from "./inter/InterDisplay-Regular.woff2";
import InterDisplayItalicWoff2 from "./inter/InterDisplay-Italic.woff2";
import InterDisplayMediumWoff2 from "./inter/InterDisplay-Medium.woff2";
import InterDisplayMediumItalicWoff2 from "./inter/InterDisplay-MediumItalic.woff2";

export const GlobalFonts = createGlobalStyle`

@font-face { font-family: "Inter"; font-style: normal; font-weight: 400; font-display: swap; src: url(${InterRegularWoff2}) format("woff2"); }
@font-face { font-family: "Inter"; font-style: italic; font-weight: 400; font-display: swap; src: url(${InterItalicWoff2}) format("woff2"); }

@font-face { font-family: "Inter"; font-style: normal; font-weight: 700; font-display: swap; src: url(${InterBoldWoff2}) format("woff2"); }
@font-face { font-family: "Inter"; font-style: italic; font-weight: 700; font-display: swap; src: url(${InterBoldItalicWoff2}) format("woff2"); }

@font-face { font-family: "InterDisplay"; letter-spacing: "-0.0175em"; font-style: normal; font-weight: 400; font-display: swap; src: url(${InterDisplayRegularWoff2}) format("woff2"); }
@font-face { font-family: "InterDisplay"; font-style: italic; font-weight: 400; font-display: swap; src: url(${InterDisplayItalicWoff2}) format("woff2"); }

@font-face { font-family: "InterDisplay"; font-style: normal; font-weight: 500; font-display: swap; src: url(${InterDisplayMediumWoff2}) format("woff2"); }
@font-face { font-family: "InterDisplay"; font-style: italic; font-weight: 500; font-display: swap; src: url(${InterDisplayMediumItalicWoff2}) format("woff2"); }
`;
